$(document).ready(function() {
  var optionsArray = [
    {
      label: 'Apple', // Group label
      options: [
        { text: 'iPhone 17 Pro Max' },
        { text: 'iPhone 17 Pro' },
        { text: 'iPhone 17' },
        { text: 'iPhone Air' },
        { text: 'iPhone 16 Pro' },
        { text: 'iPhone 16 Plus' },
        { text: 'iPhone 16' },
        { text: 'iPhone 15 Pro Max' },
        { text: 'iPhone 15 Pro' },
        { text: 'iPhone 15 Plus' },
        { text: 'iPhone 15' },
        { text: 'iPhone 14 Pro Max' },
        { text: 'iPhone 14 Pro' },
        { text: 'iPhone 14 Plus' },
        { text: 'iPhone 14' },
        { text: 'iPhone 13 Pro Max' },
        { text: 'iPhone 13 Pro' },
        { text: 'iPhone 13 Mini' },
        { text: 'iPhone 13' },
        { text: 'iPhone 12 Pro Max' },
        { text: 'iPhone 12 Pro' },
        { text: 'iPhone 12' }
      ]
    },
    {
      label: 'Samsung', // Another group
      options: [
        { text: 'Samsung Galaxy S24 Ultra' },
        { text: 'Samsung Galaxy S24' },
        { text: 'Samsung Galaxy S23 Ultra' },
        { text: 'Samsung Galaxy S23 Plus' },
        { text: 'Samsung Galaxy S22 Ultra 5G' },
        { text: 'Samsung Galaxy S22 Plus 5G' },
        { text: 'Samsung Galaxy S22 5G' },
        { text: 'Samsung Galaxy S21 Ultra' },
        { text: 'Samsung Galaxy S21 Plus' },
        { text: 'Samsung Galaxy S21' },
      ]
    },
     {
      label: 'OnePlus', // Another group
      options: [
        { text: 'OnePlus 9 Pro' },
        { text: 'OnePlus 9RT' }
      ]
    },
   {
      label: 'Google Pixel', // Another group
      options: [
        { text: 'Google Pixel 6 Pro' },
      ]
    }
  ];

  // Initialize Select2
  $('.brandSelectStride').select2({
    placeholder: "Please Choose Your Phone Model or Search", // Set the placeholder
  });

  var placeholderOption = new Option("", "", false, false);
  $('.brandSelectStride').append(placeholderOption);

  // Iterate through the optionsArray and create optgroup and options
  optionsArray.forEach(function(group) {
    // Create the optgroup for each label
    var optgroup = $('<optgroup>').attr('label', group.label);
    
    // Loop through each option within the group and create the option elements
    group.options.forEach(function(option) {
      var newOption = new Option(option.text, option.id, false, false);
      optgroup.append(newOption);
    });

    // Append the optgroup to the select element
    $('.brandSelectStride').append(optgroup);
  });

  // Trigger the change event to refresh Select2
  $('.brandSelectStride').trigger('change');
});
